<template>
   <div>
      <div class="last-sync-details" style="padding-bottom: 1rem;">Last sync {{ lastSync }}</div>
      <div class="row" style="margin-top: 0 !important;">
            <div class="col performance-details">
                  <IconHrv color="#bce1da" /> 
                  <span>HRV</span>
                  <div class="div-unit">
                    <label class="performance-label" >
                      <span style="font-size: 1rem;">{{ performance.latestData.hrv }}</span>
                      <span class="stats-unit"> ms</span>
                    </label>
                  </div>
                  <div class="div-unit">
                      <label>
                        <IconStar v-if="hrvRange == 'BETTER'" :color="inRangeColor" class="align-icon" />
                        <IconCheckCircle v-else-if="hrvRange == 'OK'" :color="inRangeColor" class="align-icon" />
                        <IconCircleWarning v-else :color="warningColor" class="align-icon" />
                        <span :style="{'color': hrvRange == 'POOR' ? warningColor : inRangeColor}">{{ performance.min_hrv }} - {{ performance.max_hrv }}</span>
                      </label>
                  </div>
              </div>
              <div class="col performance-details"> 
                  <IconRhr color="#bce1da" />
                  <span>RHR</span>
                  <div class="div-unit">
                    <label class="performance-label" >
                      <span style="font-size: 1rem;">{{ performance.latestData.rhr }}</span>
                      <span class="stats-unit"> bpm</span>
                    </label>
                  </div>
                  <div class="div-unit">
                    <label>
                        <IconStar v-if="rhrRange == 'BETTER'" :color="inRangeColor" class="align-icon" />
                        <IconCheckCircle v-else-if="rhrRange == 'OK'" :color="inRangeColor" class="align-icon" />
                        <IconCircleWarning v-else :color="warningColor" class="align-icon" />
                        <span :style="{'color': rhrRange == 'POOR' ? warningColor: inRangeColor}">{{ performance.min_rhr }} - {{ performance.max_rhr }}</span>
                    </label>
                  </div>
              </div>
              <div class="col performance-details">
                  <IconStress color="#bce1da" />
                  <span>Stress</span>

                  <div class="div-unit">
                      <label class="performance-label" >
                          <span style="font-size: 1rem;">{{ performance.latest_stress }}</span>
                      </label>
                  </div>
                  <div class="div-unit">
                      <label>
                        <IconStar v-if="stressRange == 'BETTER'" :color="inRangeColor" class="align-icon" />
                        <IconCheckCircle v-else-if="stressRange == 'OK'" :color="inRangeColor" class="align-icon" />
                        <IconCircleWarning v-else :color="warningColor" class="align-icon" />
                        <span :style="{'color': stressRange == 'POOR' ? warningColor: inRangeColor}">{{ performance.min_stress }} - {{ performance.max_stress }}</span>
                      </label>
                  </div>
              </div>
      </div>
      <div class="row" style="margin-top: 0 !important;">
              <div class="col performance-details">
                  <IconVitals color="#bce1da" />
                  <span>AVG HR</span>

                  <div class="div-unit">
                    <label class="performance-label" >
                        <span style="font-size: 1rem;">{{ performance.historicAvgPerformance.avg_hr }}</span>
                        <span class="stats-unit"> bpm</span>
                    </label>
                  </div>
              </div>
              <div class="col performance-details">
                  <IconSteps color="#bce1da" />
                  <span>Steps</span>
                  <div>
                    <label class="stats">{{ steps }}</label> 
                  </div>
              </div>
              <div class="col performance-details">
                  <IconCalories color="#bce1da" />
                  <span>Calories</span>

                  <div class="div-unit">
                    <label class="performance-label" >
                      <span style="font-size: 1rem;">{{ this.calories }}</span>
                      <span class="stats-unit"> kcal</span>
                    </label>
                  </div>
              </div>
      </div>
      <div  v-if="recommendation" style="min-height: 4rem;" class="col-12 recommendation-container">
         <div class="recommendation-details">{{ recommendation }}</div>
      </div>
      <div v-else style="height: 4rem;"></div>
   </div>
</template>

<script>
  import Utils from "@/helpers/utils.js";
  import IconCalories from "@/shared/Controls/Icons/IconCalories.vue";
  import IconVitals from "@/shared/Controls/Icons/IconVitals.vue";
  import IconHrv from "@/shared/Controls/Icons/IconHrv.vue";
  import IconRhr from "@/shared/Controls/Icons/IconRhr.vue";
  import IconSteps from "@/shared/Controls/Icons/IconSteps.vue";
  import IconStress from "@/shared/Controls/Icons/IconStress.vue";
  import IconCheckCircle from "@/shared/Controls/Icons/IconCheckCircle.vue";
  import IconCircleWarning from "@/shared/Controls/Icons/IconCircleWarning.vue";
  import IconStar from "@/shared/Controls/Icons/IconStar";
  import Constants from "@/helpers/constants";

  export default {
    name: 'UserPerformanceDetails',
    components: {
        IconCalories,
        IconVitals,
        IconHrv,
        IconRhr,
        IconSteps,
        IconStress,
        IconCheckCircle,
        IconCircleWarning,
        IconStar,
    },
    props: {
      performance: {
        type: Object,
        required: true,
      },
      data: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        recommendation: "",
        calories: 0,
        lastSync: '',
        steps: 0,
        warningColor: '#EA3323',
        inRangeColor: '#75FB4C',
        hrvRange: 'OK',
        rhrRange: 'OK',
        stressRange: 'OK'
      }
    },
    mounted() {
      this.prepareData();
    },
    methods: {
      prepareData() {
        this.preparePerformanceStats();
        this.calories = Math.round(this.performance.calories/1000);
        this.recommendation = Utils.getPerformanceRecommendation(this.data.recovery_score);
        if(this.performance.lastSyncInfo) {
          this.lastSync = Utils.formatTimestampToTimeAgo(this.performance.lastSyncInfo.last_sync);
        }
        this.steps = Utils.numberWithCommas(this.performance.steps);
      },
      preparePerformanceStats() {
        this.hrvRange = Constants.PERFORMANCE_RANGE.OK;
        this.rhrRange= Constants.PERFORMANCE_RANGE.OK;
        this.stressRange= Constants.PERFORMANCE_RANGE.OK;

        if(this.performance.latestData.hrv > this.performance.max_hrv) {
            this.hrvRange = Constants.PERFORMANCE_RANGE.BETTER;
        } else if(this.performance.latestData.hrv < this.performance.min_hrv) {
           this.hrvRange = Constants.PERFORMANCE_RANGE.POOR;
        }

        if(this.performance.latestData.rhr < this.performance.min_rhr) {
            this.rhrRange = Constants.PERFORMANCE_RANGE.BETTER;;
        } else if(this.performance.latestData.rhr > this.performance.max_rhr) {
            this.rhrRange = Constants.PERFORMANCE_RANGE.POOR;;
        }

        if(this.performance.latest_stress < this.performance.min_stress) {
            this.stressRange = Constants.PERFORMANCE_RANGE.BETTER;
        } else if(this.performance.latest_stress > this.performance.max_stress) {
            this.stressRange = Constants.PERFORMANCE_RANGE.POOR;
        }
      }
    },
    watch: {
      performance() {
        this.prepareData();
      }
    },
  }

</script>

<style scoped>
.performance-details {
    padding:0.5rem;
    text-align: left;
    color: #bce1da;
  }
  .performance-details span {
    padding-left: 0.2rem;
  }
  .stats {
    font-size: 1rem;
  }Height
  .stats-unit {
    font-size: 0.85rem;
    font-weight: 100;
  }
  .last-sync-details {
    text-align: right;
    font-size: 0.9rem;
    color: #B0B0B0;
  }
  .performance-label {
    margin-bottom: 0;
  }
  .recommendation-container {
  background-color: rgb(31, 38, 40);
  border-radius: 0.3rem;
  margin-top: 1rem;
 }
.recommendation-details { 
  font-size: 0.75rem;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  text-align: start;
  border-radius: 0.5rem;
 }
 .div-unit {
  display: flex; 
  padding: 0; 
  margin: 0; 
  gap: 0;
 }
.align-icon {
  padding-bottom: 0.1rem;
} 
</style>